import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import {
  BackgroundOperationService,
  BackgroundOperation,
} from "@app/shared/services/background-operation.service";

@Component({
  selector: "app-background-operations",
  templateUrl: "./background-operations.component.html",
  styleUrls: ["./background-operations.component.scss"],
})
export class BackgroundOperationsComponent implements OnInit, OnDestroy {
  operazioni: BackgroundOperation[] = [];
  espanso: boolean = true;
  private sub: Subscription;

  constructor(private service: BackgroundOperationService) { }

  ngOnInit(): void {
    this.sub = this.service.operazioni$.subscribe(ops => {
      this.operazioni = ops;
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  get count(): number {
    return this.operazioni.length;
  }

  toggle(): void {
    this.espanso = !this.espanso;
  }

  chiudi(op: BackgroundOperation): void {
    this.service.rimuovi(op.id);
  }

  svuotaCompletate(): void {
    this.service.svuotaCompletate();
  }

  eseguiAzione(op: BackgroundOperation): void {
    if (op.azione && typeof op.azione.azione === "function") {
      op.azione.azione(op.risultato, () => this.service.rimuovi(op.id));
    }
  }
}
